import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { Routes, urls } from '@/constants';
import { Link } from '@/containers/Link';
import { selectSessionUserId, selectUserRegion, useAppSelector } from '@/store';
import { getRedirectSearchParams } from '@/utils';

import { ProfileMenu } from './components';

export const NavbarActions = () => {
  const region = useAppSelector(selectUserRegion);
  const userId = useSelector(selectSessionUserId);

  if (userId) {
    return (
      <Box>
        <ProfileMenu />
      </Box>
    );
  }

  return (
    <Box sx={styles.container}>
      <Link to={urls.lumiq[region]} target="_blank">
        <Typography variant="h5" sx={styles.actionLink}>
          About Us
        </Typography>
      </Link>
      <Link
        to={{
          pathname: Routes.LOGIN,
          search: getRedirectSearchParams(),
        }}>
        <Typography variant="h5" sx={styles.actionLink}>
          Log In
        </Typography>
      </Link>
      <Link
        to={{
          pathname: Routes.REGISTER,
          search: getRedirectSearchParams(),
        }}>
        <Typography variant="h5" sx={styles.actionLink}>
          Sign Up
        </Typography>
      </Link>
    </Box>
  );
};

const styles = {
  container: {
    display: { xs: 'none', lg: 'flex' },
    gap: 2,
    alignItems: 'center',
    'a:hover': {
      textDecoration: 'none',
    },
  },
  actionLink: {
    color: 'grey100',
    transition: 'color 300ms',
    '&:hover': { color: 'text.contrast' },
  },
};
